<template>
  <div>
    <section class="title-box" v-if="local != 'jp'">
      <div class="container">
        <h1>{{ $t("套票種類") }}</h1>
      </div>
    </section>
    <section class="main-box">
      <div class="container">
        <div class="btn-box" v-if="local != 'jp'">
          <!-- 0517 換img圖 -->
          <div class="btn ticket-btn" id="btn">
            <router-link :to="{ name: 'MProductList' }" tag="button"><img src="img/icon-month2.png" alt="" />{{
              $t("月票")
            }}</router-link>
            <router-link :to="{ name: 'SProductList' }" tag="button"><img src="img/icon-season.png" alt="" />{{
              $t("季票")
            }}</router-link>
            <button class="btnadd">
              <img src="img/icon-time.png" alt="" />{{ $t("時數票") }}
            </button>
          </div>
        </div>
        <div class="row">
          <div class="box col-12 col-md-6 col-lg-3" v-for="Product in ProductData.Products" :key="Product.PRId">
            <img :src="SiteUrl + Product.Image" alt="" />
            <!-- 0613 擴大a連結  -->
            <router-link :to="{
              name: 'ProductBuy',
              params: { PRId: Product.PRId },
            }">
              <div class="text-box">
                <h2>{{ Product.Name }}</h2>
                <!-- <img src="static/img/icon-transportation.png" alt="" /> -->
                <div style="display: flex">
                  <img v-if="Product.IconMRT" src="img/icon_MRT.png" alt=""
                    style="margin-right: 5px; width: 32px; height: 32px" />
                  <img v-if="Product.IconLightRail" src="img/icon_LightRail.png" alt=""
                    style="margin-right: 5px; width: 32px; height: 32px" />
                  <img v-if="Product.IconBus" src="img/icon_Bus.png" alt=""
                    style="margin-right: 5px; width: 32px; height: 32px" />
                  <img v-if="Product.IconBicycle" src="img/icon_Bicycle.png" alt=""
                    style="margin-right: 5px; width: 32px; height: 32px" />
                  <img v-if="Product.IconFerry" src="img/icon_Ferry.png" alt=""
                    style="margin-right: 5px; width: 32px; height: 32px" />
                </div>
                <div class="price">
                  <p v-if="Product.OriginalPrice > 0">
                    NTD{{ Product.OriginalPrice }}
                  </p>
                  <p v-if="Product.OriginalPrice == 0"></p>
                  <p>NTD</p>
                  <p>{{ Product.Price }}</p>
                </div>
                <!-- 0613 修改 a連結改成div -->
                <div :to="{
                  name: 'ProductBuy',
                  params: { PRId: Product.PRId },
                }" class="shopping-cart">
                  <img src="img/icon-shopping-cart.png" alt="" />
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    "套票種類": "套票種類",
    "月票": "月票",
    "時數票": "時數票",
    "季票": "季票",
  },
  en: {
    "套票種類": "Pass type",
    "月票": "Monthly Pass",
    "時數票": "Hour pass",
    "季票": "Season Pass",
  },
  jp: {
    "套票種類": "フリーパスの種類",
    "月票": "月票",
    "時數票": "フリーきっぷ",
    "季票": "季票",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "ProductList",
  i18n,
  data() {
    return {
      SiteUrl: "",
      ProductData: {},
      ProductsCount: 0,
      local: "zh_tw",
    };
  },
  created: function () {
    Vue.axios
      .get(
        this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/ProductList",
        {
          params: {
            token: Storage.get("ek_login_token"),
            lang: Storage.get("ek_site_lang"),
          },
        }
      )
      .then((response) => {
        this.SiteUrl = response.data.SiteUrl;
        this.ProductData = response.data.ProductData;
        this.ProductsCount = response.data.ProductsCount;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("package-list");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  updated: function () { },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section.main-box {
  min-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductList.vue